import testService from 'ApiService/Student/testServices';
import nft1 from 'assets/img/nfts/NftBanner1.png';
import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import DailyTestQuestion from './component/Index';

const Index = ({ fetchTests, NoData }) => {
  const [test, setTest] = useState([]);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [filteredTests, setFilteredTests] = useState([]);
  const [filterOption, setFilterOption] = useState('all');
  const navigate = useNavigate();

  const fetchtest = async () => {
    setLoading(true);
    try {
      const response = await fetchTests();
      if (response.data.success) {
        setTest(response.data.assignments || []);
        setFilteredTests(response.data.assignments || []);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch test.');
    } finally {
      setLoading(false);
    }
  };

  const handleAttendanceClick = (classItem) => {
    setSelectedClass(classItem || {});
    setShowDetails(true);
  };

  const handleBackClick = () => {
    setSelectedClass(null);
    setShowDetails(false);
  };

  useEffect(() => {
    if (state?.user) {
      fetchtest();
    }
  }, [state?.user]);

  const handleFilterChange = (event) => {
    const selectedFilter = event.target.value;
    setFilterOption(selectedFilter);

    if (selectedFilter === 'all') {
      setFilteredTests(test);
    } else {
      const filtered = test.filter((t) => t.type === selectedFilter);

      if (filtered.length === 0) {
        toast.error(
          `No tests available for ${selectedFilter.toUpperCase()} type.`
        );
        setFilteredTests(test);
      } else {
        setFilteredTests(filtered);
      }
    }
  };

  return (
    <div className="mt-4 h-full w-full rounded-[20px] md:mt-5">
      <select
        id="filter"
        value={filterOption}
        onChange={handleFilterChange}
        className="ml-2 mt-5 w-[100px] cursor-pointer rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
      >
        <option value="all">All</option>
        <option value="mcq">MCQ</option>
        <option value="qa">QA</option>
      </select>
      {showDetails ? (
        <div>
          <DailyTestQuestion
            handleBackClick={handleBackClick}
            question={selectedClass}
          />
        </div>
      ) : (
        <>
          {loading ? (
            <div className="flex h-40 items-center justify-center">
              <BallTriangle color="#5431ed" />
            </div>
          ) : filteredTests.length === 0 ? (
            <div className="flex h-40 items-center justify-center dark:text-gray-600">
              <Nodatafound title={NoData} />
            </div>
          ) : (
            <div className="grid h-full w-full grid-cols-1 gap-4 p-2 md:grid-cols-2 lg:grid-cols-3">
              {filteredTests.map((branch) => (
                <span
                  key={branch._id}
                  className="relative flex h-full cursor-pointer flex-col items-center rounded-lg border border-gray-200 dark:border-gray-700 dark:!bg-navy-800 md:flex-row"
                >
                  {/* Content Section */}
                  <div className="justify flex h-full w-full flex-col p-4 leading-normal md:w-2/3">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                      {branch.title}
                    </h5>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      Time: {branch.completionTime}
                    </p>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      Total Questions: {branch.questions?.length ?? 0}
                    </p>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      Create Date:
                      {new Date(branch.createdAt).toLocaleDateString()}
                    </p>
                    <button
                      className="rounded bg-blue-500 px-4 py-2 text-white"
                      onClick={() => handleAttendanceClick(branch)}
                    >
                      Start Assignment
                    </button>
                  </div>
                </span>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Index;
